import { AxiosResponse } from 'axios';

import API from '../Common/axios';
import { RoleOptionsInterface } from '../Common/types';

// Endpoints listed here do not have a specific model and CRUD operations (for now)
export const getRolesMinimalList = (params: { hide_banned?: boolean }) => {
  return API.get<{ data: RoleOptionsInterface[] }>('v1/roles/minimal_list', { params });
};
